
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(22089|40891)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
